import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';
import { Firestore } from 'firebase/firestore';
import { Functions } from 'firebase/functions';

import { FirebaseToken } from '../../app/core/firebase.module';
import { AuthProvider } from '../auth/auth.provider';
import { CommonProvider } from '../common/common.provider';
import { AddItemsToGalleryInteractor } from './domain/interactors/add-items-to-gallery.interactor';
import { CreateGalleryInteractor } from './domain/interactors/create-gallery.interactor';
import { DeleteGalleryInteractor } from './domain/interactors/delete-gallery.interactor';
import { GetGalleryByIdInteractor } from './domain/interactors/get-gallery-by-id.interactor';
import { GetMirroredFeedItemsInteractor } from './domain/interactors/get-mirrored-feed-items.interactor';
import { GetPublicGalleryInteractor } from './domain/interactors/get-public-gallery.interactor';
import { GetTeamGalleriesInteractor } from './domain/interactors/get-team-galleries.interactor';
import { MirrorFeedItemInteractor } from './domain/interactors/mirror-feed-item.interactor';
import { MirrorGalleryItemsInteractor } from './domain/interactors/mirror-gallery-items.interactor';
import { RemoveItemsFromGalleryInteractor } from './domain/interactors/remove-items-from-gallery.interactor';
import { UpdateGalleryInteractor } from './domain/interactors/update-gallery.interactor';
import { GalleriesDefaultProvider, GalleriesProvider } from './galleries.provider';

@NgModule({
  providers: angularProvidersBuilder({
    provide: GalleriesProvider,
    deps: [AuthProvider, CommonProvider, FirebaseToken.Firestore, FirebaseToken.Functions],
    useFactory: (
      authProvider: AuthProvider,
      commonProvider: CommonProvider,
      firestore: Firestore,
      functions: Functions,
    ) => new GalleriesDefaultProvider(authProvider, commonProvider, firestore, functions),
  })
    .add(AddItemsToGalleryInteractor, (p) => p.provideAddItemsToGallery())
    .add(CreateGalleryInteractor, (p) => p.provideCreateGallery())
    .add(DeleteGalleryInteractor, (p) => p.provideDeleteGallery())
    .add(GetGalleryByIdInteractor, (p) => p.provideGetGalleryById())
    .add(GetMirroredFeedItemsInteractor, (p) => p.provideGetMirroredFeedItems())
    .add(GetPublicGalleryInteractor, (p) => p.provideGetPublicGallery())
    .add(GetTeamGalleriesInteractor, (p) => p.provideGetTeamGalleries())
    .add(MirrorFeedItemInteractor, (p) => p.provideMirrorFeedItem())
    .add(MirrorGalleryItemsInteractor, (p) => p.provideMirrorGalleryItems())
    .add(RemoveItemsFromGalleryInteractor, (p) => p.provideRemoveItemsFromGallery())
    .add(UpdateGalleryInteractor, (p) => p.provideUpdateGallery())
    .build(),
})
export class GalleriesProviderModule {}
